import io from 'socket.io-client';
class SocketService {
    constructor(apiUrl) {
        this._lazyInit = () => {
            if (this.socket) {
                return;
            }
            const url = new URL(this._apiUrl);
            if (url.pathname && url.pathname !== '/') {
                this.socket = io(url.origin, { path: `${url.pathname}/socket.io` });
            }
            else {
                this.socket = io(url.host);
            }
        };
        this._apiUrl = apiUrl;
        this.socket = null;
    }
    setMessageHandler(topic, handler) {
        var _a;
        this._lazyInit(); // fix `document` exception SSR issue inside URL
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.on(topic, handler);
    }
    removeMessageHandler(topic, handler) {
        var _a;
        this._lazyInit(); // fix `document` exception SSR issue inside URL
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.removeListener(topic, handler);
    }
}
export default SocketService;
